import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { ApiClient } from '../api'
import type { HazardLibraryCreate, HazardLibraryPatch } from '../types'

// Org-level hazard library (spec 04). Long stale time — the catalogue
// changes infrequently and the per-event Risks tab depends on it being
// available without a round-trip on every render.

export function useHazardLibrary() {
  return useQuery({
    queryKey: ['hazard-library'],
    queryFn: ApiClient.hazardLibrary,
    staleTime: 30 * 60_000
  })
}

export function useCreateHazard() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (body: HazardLibraryCreate) => ApiClient.createHazard(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['hazard-library'] })
  })
}

export function usePatchHazard() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: HazardLibraryPatch }) =>
      ApiClient.patchHazard(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['hazard-library'] })
  })
}

export function useDeleteHazard() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => ApiClient.deleteHazard(id).then(() => id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['hazard-library'] })
  })
}
